export const PLAN_PRICING = {
  basic: {
    monthly: 10,
    annual: 100,
    maxUnits: 20,
  },
  pro: {
    monthlyPerUnit: 1,
    minimumUnits: 50,
  },
} as const;

export function estimateProMonthlyTotal(units: number): number {
  return Math.max(units, PLAN_PRICING.pro.minimumUnits) * PLAN_PRICING.pro.monthlyPerUnit;
}
